import AnalyticsCompanyItemModelBase from '../_generated/modelBases/analytics-company-item-model-base';

export default class AnalyticsCompanyItemModel extends AnalyticsCompanyItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
